import { schema } from 'normalizr';

export const categorySchema = new schema.Entity('categories', {}, { idAttribute: 'CategoryId' });
export const categoryListSchema = [categorySchema];
